<template>
  <div class="ksk-keypad">
    <button
      v-for="key in keys"
      :key="key"
      type="button"
      class="ksk-keypad__key"
      :class="{
        'ksk-keypad__key--action': key === clearToken || key === backToken,
      }"
      :aria-label="key === backToken ? $t('kiosk.keyboard.backspace') : key === clearToken ? $t('kiosk.keyboard.clear') : key"
      @click="$emit('press', key)"
    >
      <span v-if="key === backToken" class="material-icons-round">backspace</span>
      <span v-else-if="key === clearToken" class="ksk-keypad__clear">{{ $t("kiosk.keyboard.clear") }}</span>
      <span v-else>{{ key }}</span>
    </button>
  </div>
</template>

<script>
// KSK005 — 3×4 numeric keypad (1-9, Clear, 0, backspace), keys ≥120×96px.
// Emits `press` with the host modal's own tokens (each modal already names its
// Clear/backspace keys differently), so the host's key handler stays unchanged.
export default {
  name: "KskNumericKeypad",
  emits: ["press"],
  props: {
    clearToken: { type: String, default: "C" },
    backToken: { type: String, default: "X" },
  },
  computed: {
    keys() {
      return ["1", "2", "3", "4", "5", "6", "7", "8", "9", this.clearToken, "0", this.backToken];
    },
  },
};
</script>

<style scoped>
.ksk-keypad {
  display: grid;
  grid-template-columns: repeat(3, minmax(120px, 1fr));
  grid-auto-rows: 96px;
  gap: var(--ksk-space-2);
  width: 100%;
  min-width: 392px;
}
.ksk-keypad__key {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  /* KSK063: keys sit on the white popup as muted tiles, no outline. */
  border: 1px solid transparent;
  border-radius: var(--ksk-radius-button);
  background: var(--ksk-surface-muted);
  color: var(--ksk-text);
  font-family: var(--ksk-font);
  font-size: 40px;
  line-height: 48px;
  font-weight: 500;
  font-variant-numeric: tabular-nums;
  overflow: hidden;
  cursor: pointer;
  user-select: none;
  transition: transform 80ms ease-out;
  -webkit-tap-highlight-color: transparent;
}
.ksk-keypad__key--action {
  background: var(--ksk-surface-muted);
  border-color: transparent;
}
.ksk-keypad__key .material-icons-round {
  font-size: 36px;
}
.ksk-keypad__clear {
  font-size: var(--ksk-label-size);
  line-height: var(--ksk-label-lh);
  font-weight: 600;
}
.ksk-keypad__key::after {
  content: "";
  position: absolute;
  inset: 0;
  background: currentColor;
  opacity: 0;
}
.ksk-keypad__key:active {
  transform: scale(0.97);
}
.ksk-keypad__key:active::after {
  opacity: 0.08;
}
</style>
